module.exports = __webpack_public_path__ + "assets/img/default-avatar.66cc0f96.png";